<mat-form-field appearance="outline" [ngClass]="{ 'new-form-field': newStyle }">
    <mat-label>{{ placeholder }}</mat-label>
    <input
        #matInput
        type="text"
        matInput
        [matAutocomplete]="auto"
        [formControl]="filterControl"
        (focus)="onfocus()"
        (blur)="onblur()"
    />
    <mat-icon matSuffix>expand_more</mat-icon>

    <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn"
        (optionSelected)="optionSelected($event.option)"
    >
        <mat-option
            *ngFor="let data of filteredOptions | async"
            [value]="data"
            [disabled]="data.selected"
            [ngClass]="{ 'no-access': data.addAccessClass }"
        >
            {{ data.label ? data.label : data.value }}
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
